const errorLang = {
  email: {
    en: 'Please check the email address format. ',
    fr: 'Veuillez vérifier le format de l’adresse courriel. '
  },
  name: {
    en: 'There are some unusual characters in your entry. This field accepts only letters, hyphens(-) or apostrophes(’).',
    fr: "Votre saisie comprend des caractères inhabituels. Ce champ n'accepte que des lettres, des tirets (-) ou des apostrophes (’)"
  },
  isAlphaNumeric: {
    en: 'There are some unusual characters in your entry. This field accepts only letters and numbers.',
    fr: 'Il y a des caractères inhabituels dans votre entrée. Ce champ n\'accepte que des lettres et des chiffres.',
  },
  postalcode: {
    en: 'Please check the postal code format. ',
    fr: 'Veuillez vérifier le format de l’adresse courriel.'
  },
  phone: {
    en: "Please enter in a valid phone number.",
    fr: "Veuillez saisir un numéro de téléphone valide."
  },
  required: {
    en: 'This is a required field.',
    fr: 'Ce champ est obligatoire.'
  },
  preferredContact: {
    en: 'This is a required field.',
    fr: 'Ce champ est obligatoire.'
  },
  subject: {
    en: 'In order to help us deal with your query quickly, we need a subject for your email.',
    fr: 'Afin de nous aider à traiter rapidement votre demande, nous avons besoin d’un sujet pour votre courriel.'
  },
  vin: {
    en: 'The Vehicle Identification Number (VIN) you have entered is not valid.',
    fr: 'Le numéro d’identification de véhicule que vous avez entré n’est pas valide.'
  },
  mb20: {
    en: 'Error: File over 20mb',
    fr: 'Erreur : Fichier de plus de 20 Mo'
  },
  odometer: {
    en: 'The odometer value you have entered must be a number.',
    fr: 'La valeur saisie pour l\'odomètre doit être un nombre.'
  },
  nameMaxMin: {
    en: 'Please enter a name between 2 and 50 characters.',
    fr: 'Veuillez entrer un nom comprenant entre 2 et 50 caractères.'
  },
  general: {
    en: 'An unknown server error occured. Try again later.',
    fr: 'Une erreur de serveur s’est produite. Veuillez réessayer plus tard.'
  },
  positive: {
    en: 'This must be a positive number.',
    fr: 'Ceci doit être un nombre positif.'
  },
  durationInvolvment: {
    en: 'ERROR MSG',
    fr: 'MSG ERREUR.'
  },
  howManyHelped: {
    en: 'ERROR MSG.',
    fr: 'MSG ERREUR.'    
  },
  dataMissing1:{
    en: '<strong>System data is missing. This page will refresh in',
    fr: '<strong>Données de système manquantes. Cette page sera actualisée dans'
  },
  dataMissing2:{
    en: 'seconds.</strong>',
    fr: 'secondes.</strong>'
  }
}

export default errorLang;